import { CircularProgress, Grid, Stack } from '@mui/material';
import { useFamilyMemberProfile } from '@pflegenavi/frontend/api-nursing-home';
import type { FC } from 'react';
import { AccountStatusCard } from './AccountStatusCard';
import { FamilyMemberProfileInfo } from './FamilyMemberProfileForm';

export const FamilyMemberProfileDetails: FC = () => {
  const { data: userProfile, isPending: isUserProfileLoading } =
    useFamilyMemberProfile({});

  if (isUserProfileLoading) {
    return (
      <Stack
        sx={{
          alignItems: 'center',
        }}
      >
        <CircularProgress
          color="primary"
          variant="indeterminate"
          sx={{ mt: 8 }}
        />
      </Stack>
    );
  }
  return (
    <Grid container spacing={3}>
      <Grid
        size={{
          xs: 12,
          lg: 8,
        }}
      >
        <FamilyMemberProfileInfo
          firstName={userProfile?.user?.firstName ?? ''}
          lastName={userProfile?.user?.lastName ?? ''}
          email={userProfile?.user?.eMail ?? ''}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          lg: 4,
        }}
      >
        <Stack spacing={3}>
          <AccountStatusCard
            active={true}
            activeSince={userProfile?.user.createdAt}
          />
        </Stack>
      </Grid>
    </Grid>
  );
};
